import React from 'react';

function BrandMark({ className = '', alt = 'GHOST 新网站 Logo' }) {
  return (
    <img
      className={className}
      src="/images/yl-logo-mark.png"
      alt={alt}
    />
  );
}

export default BrandMark;
